import { PartType } from '@/partTypes'
import { matchHighlightBoardName, translate } from '@/util/commonFun'

/** 特殊工艺筛选配置，与 store.specialRemarks 结构一致 */
export interface SpecialRemarksType {
  remarksOptions?: Record<string, unknown>
  customizeOptions?: Record<string, Record<string, unknown>>
}

/**
 * @description 合并 specialRemarks 得到用于过滤的 key->是否展示 映射
 */
export function getProcessLabelOptions(
  specialRemarks: SpecialRemarksType | null | undefined
): Record<string, unknown> {
  const remarksOptions = { ...(specialRemarks?.remarksOptions ?? {}) }
  const customizeOptions = specialRemarks?.customizeOptions
  if (customizeOptions) {
    Object.values(customizeOptions).forEach((obj) => {
      Object.assign(remarksOptions, obj)
    })
  }
  return remarksOptions
}

/**
 * @description 处理板件特殊工艺文案显示（支持按 specialRemarks 过滤）
 * @param part 板件信息
 * @param specialRemarks 可选，与 getSpecialRemarks 接口返回的 data.data 结构一致；不传则展示全部
 * @returns 拼接后的特殊工艺文案字符串
 */
export function processLabelFn(
  part: PartType,
  specialRemarks?: SpecialRemarksType | null
): string {
  if (!part?.process_label) return ' '
  const processMarkArr: string[] = []
  const options = getProcessLabelOptions(specialRemarks)
  const needFilter =
    Object.keys(options).length > 0 &&
    !Object.values(options).every((item) => item)

  if (needFilter) {
    part.process_label?.auto_label?.forEach((item) => {
      if (options[Object.keys(item)[0]]) {
        const val = Object.values(item)[0]
        if (val) processMarkArr.push(val as string)
      }
    })
  } else {
    part.process_label?.auto_label?.forEach((item) => {
      const val = Object.values(item)[0]
      if (val) processMarkArr.push(val as string)
    })
  }
  part.process_label.custom_label?.forEach((item) => {
    if (item) processMarkArr.push(item)
  })
  return processMarkArr.length > 0 ? processMarkArr.join('/') : ' '
}

/**
 * @description 处理料单单行上显示铰链的孔位信息文案
 * @param part 板件信息
 */
export function showMaterialHingeinfo(part: PartType) {
  if (!part) return ''
  const {
    hingeInfo,
    openDir,
    oRect: { width, height },
  } = part
  // 判断方向
  if (!hingeInfo?.length) return ''
  const isTowardsRightOpen = ['左开', '右开'].includes(openDir)
  // 左右开的情况下 铰链是在左右两边所以用高度减去反之宽度
  const calcNum = isTowardsRightOpen ? height : width
  const nHinges = hingeInfo
    .map((n) => `${(calcNum - n).toFixed(2)}`)
    .sort((a, b) => +a - +b)
  const dirText = isTowardsRightOpen
    ? translate('materialPage.distanceFromTop')
    : translate('materialPage.distanceFromRight')
  return `${dirText}${nHinges.join('/')}`
}
/**
 * @description 处理料单上高光显示
 * @param part 板件信息
 */
export function showMaterialHighGloss(part: PartType) {
  if (!part) return ''
  return part.is_high_gloss_plank
    ? matchHighlightBoardName(part.matCode)
    : `非${matchHighlightBoardName(part.matCode)}`
}
